import { useMutation } from "@tanstack/react-query";
import { resetAgentStepUpPassword } from "@/api/agents";

export const useResetAgentStepUpPassword = () => {
  return useMutation({
    mutationFn: resetAgentStepUpPassword,
  });
};
